
export default {
  name: "UnitCategoryInList",
  data() {
    return {
      isOpenGallery: false
    }
  },
  props: {
    unitCategory: {
      type: Object,
      default: null
    },
    single: {
      type: Boolean,
      default: false
    },
    unitHasData : {
      type: Boolean,
      default: false
    }
  },
}

